
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tuotteet/naytaliunetuoteperhelista/[slug]",
      function () {
        return require("private-next-pages/tuotteet/naytaliunetuoteperhelista/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tuotteet/naytaliunetuoteperhelista/[slug]"])
      });
    }
  